import { useAccess as useAccessBase, useAccessInList as useAccessInListBase } from "../../../utils/hooks/access";

export const useAccess = (accessPath: string): boolean => useAccessBase(accessPath).hasAccess;
export const useAccessInList = (accessPaths: string[]): boolean => useAccessInListBase(accessPaths).hasAccess;
